import { render, staticRenderFns } from "./ViewEvento.vue?vue&type=template&id=ac1da95c&"
import script from "./ViewEvento.vue?vue&type=script&lang=js&"
export * from "./ViewEvento.vue?vue&type=script&lang=js&"
import style0 from "./ViewEvento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports